<template>
 <body>

  <!-- header for tv START -->
  <div class="header header-tv">

    <!-- col-1 start -->
    <div class="col-1">

    <!-- start logo tv -->
      <div class="leftcol-banner logoTv">
        <img src="@/assets/images/banner-1.svg" alt="" />
      </div>
    <!-- stop logo tv -->

    </div>
    <!-- col-1 stop -->

    <!-- col-2 start -->
    <div class="col-2">

      <!-- jackpot start -->
      <div class="jackpotBox">
        <img src="@/assets/images/jackpot.svg" alt="" />
        <div class="jackpotNumber" v-if="$store.state.jackpot">{{$store.state.jackpot.Amount.toFixed(2)}}</div>
      </div>
      <!-- jackpot stop -->

    </div>
    <!-- col-2 stop -->

    <!-- col-1 start -->
    <div class="col-1">

      <div class="start">START</div>

      <!-- start -->
      <div class="counterTime" v-on="countDownTimer()" v-if="game">
        <div>0</div>
        <div>{{game.time.min[0]}}</div>
        <i>:</i>
        <div>{{game.time.sec.length == 2 ? game.time.sec[0] : 0}}</div>
        <div>{{game.time.sec.length == 2 ? game.time.sec[1] : game.time.sec[0]}}</div>
      </div>
      <!-- stop -->

    </div>
    <!-- col-1 stop -->

  </div>
  <!-- header for tv STOP -->

  <!-- main START -->
  <div class="main">

    <div class="tab9-box tabСlient tabСlient-0">

      <table class="tab9-table" v-if="$store.state.game">

        <!-- table client header start -->
        <tr>

          <th>
            <div class="league-weektv">
              <div class="leaguetv" v-if="$store.state.game">
                <div>{{$t('league')}}</div>
                <div>{{$store.state.game.League}}</div>
              </div>

              <div class="weektv" v-if="$store.state.game">
                <div>{{$t('week')}}</div>
                <div>{{$store.state.game.Week}}</div>
              </div>
            </div>
          </th>

          <th colspan="14">

            <div class="thBox">

              <div class="pBlock">
                <p>{{$t('cors')}} ({{$t('htw')}})</p>
              </div>

              <div class="thBlock">
                <div>1-0</div>
                <div>2-0</div>
                <div>3-0</div>
                <div>4-0</div>
                <div>5-0</div>
                <div>6-0</div>
                <div>2-1</div>
                <div>3-1</div>
                <div>4-1</div>
                <div>5-1</div>
                <div>3-2</div>
                <div>4-2</div>
                <div>0-0</div>
                <div>1-1</div>
              </div>

            </div>

          </th>

        </tr>
        <!-- table client header stop -->

        <tr class="trSeparator">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <!-- tr start repeat -->
        <tr v-for="(item, index) in $store.state.game.Match" v-if="$store.state.game">
          <td>
            <div>
              <span>{{index+1}}</span>
              <span><img :src="getimg(item.HomeTeam)" alt=""></span>
              <span>{{getteams(item.HomeTeam)}}</span>
              <span>VS</span>
              <span>{{getteams(item.AwayTeam)}}</span>
              <span><img :src="getimg(item.AwayTeam)" alt=""></span>
            </div>
          </td>
          <td>
            <p>{{item.Odds['1-0']}}</p>
          </td>
          <td>
            <p>{{item.Odds['2-0']}}</p>
          </td>
          <td>
            <p>{{item.Odds['3-0']}}</p>
          </td>
          <td>
            <p>{{item.Odds['4-0']}}</p>
          </td>
          <td>
            <p>{{item.Odds['5-0']}}</p>
          </td>
          <td>
            <p>{{item.Odds['6-0']}}</p>
          </td>
          <td>
            <p>{{item.Odds['2-1']}}</p>
          </td>
          <td>
            <p>{{item.Odds['3-1']}}</p>
          </td>
          <td>
            <p>{{item.Odds['4-1']}}</p>
          </td>
          <td>
            <p>{{item.Odds['5-1']}}</p>
          </td> 
          <td>
            <p>{{item.Odds['3-2']}}</p>
          </td>
          <td>
            <p>{{item.Odds['4-2']}}</p>
          </td>
          <td>
            <p>{{item.Odds['0-0']}}</p>
          </td>
          <td>
            <p>{{item.Odds['1-1']}}</p>
          </td>
        </tr>
        <!-- tr stop repeat -->
      </table>
    </div>
  </div>
  <!-- main STOP -->


  <tvfooter></tvfooter>

</body>
</template>

<script>
import tvfooter from '@/components/TVfooter.vue'
import countdown from '@/components/tvcountdown.js'
import Cookies from 'js-cookie'

export default {
  name: 'TV',
  timer: 0,
  mixins: [countdown],
  created: function () {
    this.$i18n.locale = this.$route.params.lang;
      this.$store.dispatch('apirequest', { name: "jackpot/"+this.$route.params.Token});
      this.$store.dispatch('apirequest', { name: "jackpot/last/"+this.$route.params.Token});
      this.$store.dispatch('apirequest', { name: "game/results"});
      this.$store.dispatch('apirequest', {name: "teams/"}).then(()=>{
        this.$store.state.teams.sort((a, b) => a.Score - b.Score).reverse()
      });
      this.$store.dispatch('apirequest', {token: 0, name: "game/"}).then((response) => {
        this.$store.state.Time = Math.floor((response.data.Time - Date.now()) / 1000 );
      });
  },
  components: {
    tvfooter
  },    
};
</script>

